var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"flex-1 spinner-cnt",attrs:{"justify":"center","type":"flex"}},[_c('a-spin',{attrs:{"size":"large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }